<div #container>
  <router-outlet></router-outlet>
</div>
